import {
  DEFAULT_PROMOTIONAL_PHOTO_FINANCING_DISPLAY,
  PromotionalPhotoFinancingDisplay,
} from '@dms/api/settings';
import {FinancialProductType} from '@dms/api/shared';

export interface FinancingDisplayDraft extends PromotionalPhotoFinancingDisplay {
  checkedProducts: FinancialProductType[];
}

// The list always shows every product. Products missing from a saved PREFERRED order are listed
// after the saved ones (in the default priority) and start unchecked.
export const createFinancingDisplayDraft = (
  saved: PromotionalPhotoFinancingDisplay
): FinancingDisplayDraft => {
  const missingProducts = DEFAULT_PROMOTIONAL_PHOTO_FINANCING_DISPLAY.order.filter(
    (type) => !saved.order.includes(type)
  );
  const order = [...saved.order, ...missingProducts];
  return {
    mode: saved.mode,
    order,
    checkedProducts: saved.mode === 'PREFERRED' ? saved.order : order,
  };
};

// PREFERRED saves only the checked products, in the displayed order; ALL ignores the checkboxes
// and keeps the full order.
export const getFinancingDisplayRequest = (
  draft: FinancingDisplayDraft
): PromotionalPhotoFinancingDisplay => ({
  mode: draft.mode,
  order:
    draft.mode === 'PREFERRED'
      ? draft.order.filter((type) => draft.checkedProducts.includes(type))
      : draft.order,
});
